import React, { useState } from "react";
import { Button } from "./ui/button";
import { Phone, Menu, X } from "lucide-react";
import Logo from "./Logo";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToOfferForm = () => {
    const offerSection = document.getElementById('offer-submission');
    if (offerSection) {
      offerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Logo size="normal" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              About Us
            </button>
            <button 
              onClick={scrollToOfferForm}
              className="text-gray-700 hover:text-blue-600 transition-colors"
            >
              Get Offer
            </button>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="tel:1-888-334-3524"
              className="flex items-center text-green-600 hover:text-green-700 font-semibold transition-colors"
            >
              <Phone className="h-4 w-4 mr-2" />
              1-888-334-3524
            </a>
            <Button 
              onClick={scrollToOfferForm}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Get My Offer
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-blue-600"
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-100 py-4">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('how-it-works')}
                className="text-gray-700 hover:text-blue-600 px-4 py-2 text-left"
              >
                How It Works
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-blue-600 px-4 py-2 text-left"
              >
                About Us
              </button>
              <button 
                onClick={scrollToOfferForm}
                className="text-gray-700 hover:text-blue-600 px-4 py-2 text-left"
              >
                Get Offer
              </button>
              <div className="px-4 py-2">
                <a
                  href="tel:1-888-334-3524"
                  className="flex items-center text-green-600 hover:text-green-700 font-semibold mb-3"
                >
                  <Phone className="h-4 w-4 mr-2" />
                  1-888-334-3524
                </a>
                <Button 
                  onClick={scrollToOfferForm}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                >
                  Get My Offer
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;